import "./index.scss";
import { Badge } from "@wise-emotions/react-badge";
import { CardBlock } from "components/Cards/components/CardBlock";
import React, { ReactNode } from "react";
import cn from "classnames";

export type CardFullImageProps = {
  image: ReactNode;
  title: string;
  description: ReactNode;
  ctaLabel: string;
  centered?: boolean;
  isPromo?: boolean;
  customClass?: string;
};

const CardFullImage = ({
  image,
  title,
  description,
  ctaLabel,
  centered,
  isPromo,
  customClass,
}: CardFullImageProps) => (
  <div className={cn("card-full-image", customClass, {})}>
    {isPromo && (
      <div className="card-full-image__badge">
        <Badge
          variant="iconAndLabel"
          theme="promo"
          contrast="high-contrast"
          label="Promo"
        />
      </div>
    )}
    <div className="card-full-image__image">{image}</div>
    <div className="card-full-image__content">
      <CardBlock
        centered={centered}
        title={title}
        description={description}
        ctaLabel={ctaLabel}
      />
    </div>
  </div>
);

export default CardFullImage;
